import { Query } from '../../_base/actionBus/Query';
import { ClaimActivity } from '../../models/claims/activity/ClaimActivity';

export class GetClaimActivity extends Query<ClaimActivity[]> {
    constructor(public claimId: number) {
        super();
    }
}
